import React from 'react';

const QuantityStep = ({ selectedQuantity, onSelect, product, stepConfig }) => {
  // Get product type name for display
  const getProductTypeName = () => {
    if (product === 'windows' || product === 'aluminium-windows') {
      return 'windows';
    }
    if (product === 'front-back-doors' || product === 'aluminium-doors') {
      return 'doors';
    }
    if (product === 'internal-products') {
      return 'internal doors/windows';
    }
    if (product === 'bifolding-sliding-french-doors') {
      return 'doors';
    }
    return 'items';
  };

  const productTypeName = getProductTypeName();
  const question = stepConfig?.question?.replace('{productType}', productTypeName) ||
                   `How many ${productTypeName} are you looking to replace/add?`;
  const options = stepConfig?.options || ['1', '2', '3', '4', '5', '6+', 'I\'m not sure'];

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-6 text-center text-[24px] font-bold text-black">
        Share your requirements
      </h2>

      {/* Question */}
      <p className="mx-auto mb-8 text-center text-lg text-gray-700">
        {question}
      </p>

      {/* Quantity Grid */}
      <div className="mx-auto max-w-[700px] px-4">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {options.map((option) => (
            <button
              key={option}
              onClick={() => onSelect(option)}
              type="button"
              className={`
                group relative flex min-h-[80px] items-center justify-center rounded-lg border-2 p-4 transition-all
                ${
                  selectedQuantity === option
                    ? 'border-[#ED6B64] bg-gray-50'
                    : 'border-gray-200 hover:border-gray-300'
                }
                ${option === 'I\'m not sure' ? 'col-span-2 sm:col-span-3 md:col-span-4' : ''}
              `}
            >
              {/* Quantity Text */}
              <span className="text-center text-base font-bold text-black">
                {option}
              </span>

              {/* Selected Indicator */}
              {selectedQuantity === option && (
                <div className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#ED6B64]">
                  <svg
                    className="h-4 w-4 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              )}
            </button>
          ))}
        </div>

        {/* Note */}
        <div className="flex items-center justify-center w-full">
          <p className="mt-8 text-center text-base text-gray-600">
            Don't worry if you're not sure - we can help you determine the exact requirements during your consultation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuantityStep;
